import { render, staticRenderFns } from "./NewResultado.vue?vue&type=template&id=2fdad772&scoped=true&"
import script from "./NewResultado.vue?vue&type=script&lang=js&"
export * from "./NewResultado.vue?vue&type=script&lang=js&"
import style0 from "./NewResultado.vue?vue&type=style&index=0&id=2fdad772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdad772",
  null
  
)

export default component.exports